/**
 * Where a new post goes (#130, 1.115.0): before or after a chosen post, in
 * the trip chat and in its draft. Null is the end.
 *
 * One shape for every road a post takes -- the line, the plus menu's sheets,
 * the separator's sheet -- and one place that turns it into the request's
 * fields (`insertionFields()`), so that no road forgets one.
 *
 * **Only with a net** (decided from use: "offline keine erweiterten
 * Bearbeitungen; nur neue Beiträge am Ende"). The outbox knows no insertion;
 * a road that would queue it says so instead (`melde()`).
 */
export interface Insertion {
  id: number
  where: 'before' | 'after'
}

/**
 * The place alone, without what a road hangs on it (the bar's text, its
 * callbacks): what goes to a hook and into a send key. One place, because it
 * stood three times as `{ id: insertion.id, where: insertion.where }`.
 */
export function insertionPlace(insertion: Insertion | null | undefined): Insertion | null {
  return insertion ? { id: insertion.id, where: insertion.where } : null
}

export function insertionFields(insertion: Insertion | null | undefined): { before_id?: number; after_id?: number } {
  if (!insertion) return {}
  return insertion.where === 'before' ? { before_id: insertion.id } : { after_id: insertion.id }
}
